import React from 'react';

import ServiceUpsertFrom from './ServiceUpsertFrom';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ServiceUpsertModal(props) {
    const close = () => {
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={props.service ? $t('Edit Service') : $t('Create Service')} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.loading ? (
                            <LoadingSpinner />
                        ) : (
                            <div className="modal__form-container">
                                <ServiceUpsertFrom
                                    service={props.service}
                                    storeUrl={props.storeUrl}
                                    updateUrl={props.updateUrl}
                                    onCancel={close}
                                    onSuccess={() => {
                                        props.onSuccess();
                                        close();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
